import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Drawer from '@mui/material/Drawer';
import Select from "react-select";
import DatePickerWrapper from "../../../components/Forms/Pickers/DatePicker";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav } from "react-bootstrap";
import DatePicker from 'react-multi-date-picker';
import axios from 'axios';
import delivery from '../../../../images/delivery.jpg';
import food_map from '../../../../images/food_maps.ico';
import route_map from '../../../../images/route_map.png';
import { QRCodeSVG } from 'qrcode.react'; 
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";

const Delivery = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // all area dropdown
    const [areaOption, setAreaOption] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`);
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.area_name,
                }));
                setAreaOption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // all area dropdown
    const [dpoption, setdpoption] = useState([]);
    const [dp, setdp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/getdp/${branch_id}`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.name,
                }));
                setdpoption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // all product dropdown
    const [productoptions, setProductoption] = useState([]);
    const [product, setSelectedProducts] = useState('');
    useEffect(() => {
        const fetchdata = async () => {
            try {
            const response = await axios.get(`${baseURL}/manage-products/products/active`);
            const formatted = response.data.data.map(item => ({
                value: item.sno,
                label: item.product_name,
            }));
            setProductoption(formatted);
            } catch (error) {
            console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    const [optionsSchedule, setOptionsSchedule] = useState([]);
    const [schedule, setSchedule] = useState(null);
    useEffect(() => {
        const fetchSchedules = async () => {
            try {
                const response = await axios.get(`${baseURL}/item-schedule/items/active`);
                if (response.status === 200 && response.data.data) {
                    const schedules = response.data.data.map(item => ({
                        value: item.sno,
                        label: item.itemschedule_name,
                    }));
                    setOptionsSchedule(schedules);
                    // setSchedule(schedules[schedules.length - 1]);
                }
            } catch (error) {
                console.error('Error fetching schedules:', error);
            }
        };

        fetchSchedules();
    }, []);

    const [date, setdate] = useState('');
    const handleDateChange = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
          setdate(formattedDate);
        } else {
          setdate(null);
        }
    };

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const [trip_link, settriplink] = useState(null);

    const fetchData = (filter = {}) => {
        const params = {
            // ...filter,      // spread existing filter key-values
            // page,           // add page number
            // per_page: perPage, // add per_page
            // search: searchTerm  // add search string
            date: date,
            // area: area,
            product: product,
            dp: dp,
            schedule: schedule.value,
        };
        axios.get(`${baseURL}/delivery/data`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                settriplink(response.data.link);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // useEffect(() => {
    //     fetchData();
    // }, [date, area])


    const [isFocused, setIsFocused] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        if (isFocused) {
            console.log('The input is focused!');
        }
    }, [isFocused]);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };
    const customStyles = {
        control: (base, state) => ({
            ...base,
            boxShadow: state.isFocused ? `0 0 0 1px #3b5220` : base.boxShadow,
            borderColor: state.isFocused ? "#3b5220" : '#ffffff',
            transition: "all 0.3s ease",
            borderBottom: '1px solid',
            fontSize: '1rem', // Set font size here
            '&:hover': {
                // borderColor: '#3b5220', // Apply border color on hover
                boxShadow: '0 0 0 1px #3b5220', // Apply box-shadow on hover
            }
        }),

        // Option styling (hover, selected, and clicked)
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? '#cfe0bd'  // Selected option background color
                : state.isFocused
                    ? '#76a54159' // Hovered option background color
                    : base.backgroundColor, // Default background color
            color: state.isSelected || state.isFocused ? '#000000' : base.color, // Text color for selected or hovered options
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:active': {
                backgroundColor: '#cfe0bd', // Ensure the background color remains #cfe0bd when option is clicked (active state)
            }
        }),

        // For selected value styling in the control box
        singleValue: (base) => ({
            ...base,
            color: '#000000', // Text color for selected value
        }),

        // Clear indicator styling (if necessary)
        clearIndicator: (base) => ({
            ...base,
            color: '#000000', // Clear icon color
        }),

        // Indicator separator styling
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: '#ffffff', // Set the background color of the separator to white
        }),
    };
    const options = [
        { value: "", label: "Select Delivery Point" },
        { value: "all", label: "All" },
        { value: "Anna Nagar", label: "Anna Nagar" },
        { value: "Southgate", label: "Southgate" },
        { value: "Avaniyapuram", label: "Avaniyapuram" },
        { value: "Theppakulam", label: "Theppakulam" },
        { value: "Periyarnagar", label: "Periyarnagar" },
    ];
    const options_date = [
        { value: "", label: "Select Date" },
        { value: "all", label: "All" },
        { value: "Today", label: "Today" },
        { value: "This week", label: "This week" },
        { value: "This Month", label: "This Month" },
        { value: "Custum Date", label: "Custum Date" }
    ];

    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if(hasFetched) {
                if (!$.fn.dataTable.isDataTable(table)) {
                    $(table).DataTable({
                        "responsive": true,
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        });
    }, [hasFetched]);

    const resetall = () => {
        setHasFetched(false);
        setData([]);
        setdate('');
        setArea(null);
    }

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!date) {
            newErrors.date = "This Field is Required.";
        }

        if (!dp) {
            newErrors.dp = "This Field is Required.";
        }

        if(!schedule) {
            newErrors.sch = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors(validationErrors);

        fetchData();
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Delivery</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Delivery Management</li>
                    </ol>
                </div>
                <div className='d-flex'>
                    {/* <Button className="me-2 btn-sm" variant="primary" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className='fw-bold'>Filter</span>
                    </Button> */}
                    {/* <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className='me-2'><i className="fa-solid fa-circle-down fs-8"></i></span>
                            <span className='fw-bold'>Export</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="#"><label className='text-black'>
                                <span><i className="fa-solid fa-file-csv me-2 fs-4"></i></span>CSV
                            </label></Dropdown.Item>
                            <Dropdown.Item href="#"><label className='text-black'>
                                <span><i className="fa-solid fa-file-excel me-2 fs-4"></i></span>Excel
                            </label></Dropdown.Item>
                            <Dropdown.Item href="trip-sheets/print-trip-sheets"><label className='text-black'>
                                <span><i className="fa-solid fa-print me-2 fs-4"></i></span>Print
                            </label></Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
                </div>
            </div>

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='border-bottom mb-4 px-4 py-2'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Filter</h5>
                </div>
                <div className='row mb-2 px-4 py-2'>
                    <div style={{ minHeight: '400px', overflowY: 'auto' }}>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Delivery Point <span className="required">*</span></label>
                            <Select
                                isMulti
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={options}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                styles={customStyles}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date <span className="required">*</span></label>
                            <Select
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={options_date}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                styles={customStyles}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date <span className="required">*</span></label>
                            <div className='d-block mt-2'>
                                <DatePickerWrapper />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-1">
                        <Button className="me-2 btn-sm" variant="primary">
                            <span className='fw-bold fs-6'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary">
                            <span className='fw-bold fs-6'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

            <div className="row mb-3">
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Date'
                            format="DD-MM-YYYY"
                            onChange={handleDateChange}
                        />
                    </div>
                    {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                </div>
                <div className="col-lg-3">
                    <label className="text-black font-w500 fs-7">Delivery Point<span className="required">*</span></label>
                    <Select placeholder={'Select Delivery Point'}
                        options={dpoption}
                        onChange={(e) => setdp(e.value)}
                    />
                    {errors.dp && <div className="text-danger fs-8 mt-1">{errors.dp}</div>}
                </div>
                <div className="col-lg-3">
                    <label className="text-black font-w500 fs-7">Schedule<span className="required">*</span></label>
                    <Select placeholder={'Select Schedule'}
                        options={optionsSchedule}
                        value={schedule}
                        onChange={setSchedule}
                    />
                    {errors.sch && <div className="text-danger fs-8 mt-1">{errors.sch}</div>}
                </div>
                {/* <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Product</label>
                    <Select placeholder={'Select Product'} 
                        options={productoptions}
                        onChange={(e) => setSelectedProducts(e.value)}
                    />
                </div> */}
                
                <div className="col-lg-3 mt-4 d-flex align-content-center">
                    {/* <Button className="me-2 btn-sm" variant="secondary" onClick={resetall}>
                        <span className='font-w400'>Reset</span>
                    </Button> */}
                    <div className='  align-items-center justify-content-start gap-1'>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleSubmit}>
                            <span className='font-w400'>Fetch</span>
                        </Button>
                    </div>
                    {trip_link && (
                        <>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Trip Route</span></Tooltip>} >
                                <Link to={trip_link} target="_blank">
                                    <img
                                        src={route_map}
                                        alt="Food Map"
                                        className='w-45px h-45px'
                                    />
                                </Link>
                            </OverlayTrigger>
                            
                            <QRCodeSVG
                                value={trip_link}
                                size={200}
                                bgColor="#ffffff"
                                fgColor="#000000"
                                level="H"
                                includeMargin={true}
                            />
                        </>
                    )}
                </div>
                
            </div>
            
            {hasFetched ? (
                <div className="table-container">

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{  fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{  fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-100px'>Customer</th>
                                <th className='min-w-100px'>Contact</th>
                                <th className='min-w-125px'>Area</th>
                                <th className='min-w-100px text-center'>Address</th>
                                <th className='min-w-100px'>Product</th>
                                <th className='min-w-125px text-center'>Package Count</th>
                                <th className='min-w-125px text-center'>Status</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {datas.length === 0 && hasFetched ? (
                                <tr>
                                    <td colSpan="6" className="text-center text-muted py-2">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {datas.map((data, index) => (
                                        <tr key={data.sno}>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.customer_name}</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.mobile_no}</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.area_name}</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.address}</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.product_name ?? '-'}</label>
                                            </td>
                                            <td className='text-center'>
                                                <Badge bg="info" className='text-white fs-8 py-0 px-1'>{data.product_count}</Badge>
                                            </td>
                                            <td className='text-center'>
                                                {data.delivery_status === 1 && (
                                                    <Badge bg="none" className='border border-primary text-primary fs-8 py-0 px-1'>Delivered</Badge>
                                                )}
                                                {data.delivery_status === 0 && (
                                                    <Badge bg="none" className='border border-danger text-danger fs-8 py-0 px-1'>Pending</Badge>
                                                )}
                                                {data.delivery_status === 2 && (
                                                    <Badge bg="none" className='border border-info text-info fs-8 py-0 px-1'>Returned</Badge>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            )}
                            
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {datas.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                </span>
                            ):(
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>

                    </div>

                </div>
            ) : (
                <div className="text-center mt-2">
                    <img src={delivery} className='h-350px mt-4' alt="delivery" />
                </div>
            )}

        </>
    )


}
export default Delivery;